import React, { useEffect, useRef, useState } from "react";
import Homex from "../../../Assets/Images/Envelope.jpg";
import UpperPage from "../../../Components/UpperPage/UpperPage";
import Intro from "./Components/Intro";
import "./Home.css";
import MakeOurNumbers from "./Components/MakeOurNumbers";
import { useInView } from "react-intersection-observer";
import SearchForm from "./Components/SearchForm";

const Home = () => {
  const { ref: viewportRef, inView } = useInView({
    threshold: 0,
    triggerOnce: true
  });

  return (
    <div>
      <UpperPage
        BackgroundImage={Homex}
        Title={"Najma Walk"}
        Description={"Contact our Home Realtors team today to find the home of your dreams."}
        Height={"100vh"}
        centrilze={"300px"}
      />

      <div className="container">
        <Intro />
      </div>

      <div ref={viewportRef}>
        <MakeOurNumbers Visible={inView} />
        <SearchForm />
      </div>
    </div>
  );
};

export default Home;
